import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectableCategory } from '../../../models/categories/category.models';

@Component({
    selector: 'mat-category-tree-root',
    template: require('./mat.category.tree.root.html')
})
export class MatCategoryTreeRoot {
    private _categories: Array<SelectableCategory>;
    @Input() maxSelected = 1000;

    @Input()
    set categories(categories: Array<SelectableCategory>) {
        categories.forEach((category: SelectableCategory) => { this.setShowCategory(category); });

        this._categories = categories;
    }

    private setShowCategory(category: SelectableCategory) {
        category.children.forEach((c: SelectableCategory) => { this.setShowCategory(c); });

        category.show = true;
    }

    get categories() {
        return this._categories;
    }

    @Output() selectedChanged = new EventEmitter<any>();

    onSelectedChanged(event) {
        this.selectedChanged.emit(event);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/category.tree.view/mat.category.tree.root.ts